import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import FixedAsset from 'models/FinancialProjections/FixedAsset';
import { byId } from 'store/utils/sortFunctions';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
      byScenario: {},
      totalByScenario: {},
      totalAquiredByScenario: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

const sumAssetTotals = (prev, asset) => prev + parseFloat(asset.value);

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FIXED_ASSETS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results.reduce(
              (prevData, asset) =>
                prevData.set(asset.id.toString(), new FixedAsset(asset)).sort(byId),
              state.get('data').get('byId')
            ),
            byScenario: state
              .get('data')
              .get('byScenario')
              .set(
                action.payload.scenario.toString(),
                fromJS(action.payload.results.map(asset => new FixedAsset(asset)).sort(byId))
              ),
            totalByScenario: state
              .get('data')
              .get('totalByScenario')
              .set(
                action.payload.scenario.toString(),
                action.payload.results.reduce(sumAssetTotals, 0)
              ),
            totalAquiredByScenario: state
              .get('data')
              .get('totalAquiredByScenario')
              .set(
                action.payload.scenario.toString(),
                fromJS(
                  action.payload.results.filter(asset => asset.acquired).reduce(sumAssetTotals, 0)
                )
              ),
          },
        })
      );
    case types.FIXED_ASSET_FETCH_SUCCEEDED:
    case types.FIXED_ASSET_CREATE_SUCCEEDED:
    case types.FIXED_ASSET_UPDATE_SUCCEEDED:
      return (() => {
        const scenarioId = action.payload.scenario.toString();
        const scenarioFixedAssets = state
          .get('data')
          .get('byScenario')
          .get(scenarioId, new List())
          .filter(asset => asset.id !== action.payload.id)
          .push(new FixedAsset(action.payload))
          .sort(byId);
        const scenarioTotal = scenarioFixedAssets.reduce(sumAssetTotals, 0);
        const secenarioAcquiredTotal = scenarioFixedAssets
          .filter(asset => asset.acquired)
          .reduce(sumAssetTotals, 0);
        return state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(action.payload.id.toString(), new FixedAsset(action.payload)),
              byScenario: state.get('data').get('byScenario').set(scenarioId, scenarioFixedAssets),
              totalByScenario: state
                .get('data')
                .get('totalByScenario')
                .set(scenarioId, scenarioTotal),
              totalAquiredByScenario: state
                .get('data')
                .get('totalAquiredByScenario')
                .set(scenarioId, secenarioAcquiredTotal),
            },
          })
        );
      })();
    case types.FIXED_ASSET_FETCH:
    case types.FIXED_ASSET_CREATE:
    case types.FIXED_ASSET_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.FIXED_ASSET_DELETE_SUCCEEDED:
      return (() => {
        const scenarioId = action.payload.scenario.toString();
        const scenarioFixedAssets = state
          .get('data')
          .get('byScenario')
          .get(scenarioId, new List())
          .filter(asset => asset.id !== action.payload.id)
          .sort(byId);
        const scenarioTotal = scenarioFixedAssets.reduce(sumAssetTotals, 0);
        const secenarioAcquiredTotal = scenarioFixedAssets
          .filter(asset => asset.acquired)
          .reduce(sumAssetTotals, 0);
        return state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state.get('data').get('byId').delete(action.payload.id.toString()),
              byScenario: state.get('data').get('byScenario').set(scenarioId, scenarioFixedAssets),
              totalByScenario: state
                .get('data')
                .get('totalByScenario')
                .set(scenarioId, scenarioTotal),
              totalAquiredByScenario: state
                .get('data')
                .get('totalAquiredByScenario')
                .set(scenarioId, secenarioAcquiredTotal),
            },
          })
        );
      })();
    case types.FIXED_ASSET_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.FIXED_ASSET_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.FIXED_ASSET_FETCH_FAILED:
    case types.FIXED_ASSETS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
